import { ICategory } from "@eventr/common";
import { Icon, TEventrIcons } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import i18n from "i18n/i18next";
import { useMemo } from "react";
import { getCategoryColours } from "utils";
import { useFormatValue } from "../../hooks/useFormatValue";
import { useScreenTypeContext } from "../../state/screenTypeProvider";
import { isSameDay } from "../card-utils";
import { useObjectContext } from "../providers/objectProvider";
import { CardText } from "../subComponents/cardText";
import { ColouredIcon } from "../subComponents/colouredIcon";
import { DisplayLabel } from "../subComponents/displayLabel";

interface IFlightHeaderProps {
  flightNumber: string;
  label: string;
  labelTime?: string;
  visibility?: string;
  departure?: string;
  arrival?: string | undefined;
  checkIn?: string | undefined;
  category?: ICategory | undefined;
  date?: string | undefined;
}

export const FlightHeader = ({
  flightNumber,
  label,
  labelTime,
  visibility,
  departure,
  arrival,
  checkIn,
  category,
  date,
}: IFlightHeaderProps) => {
  const { past } = useObjectContext();
  const { formatValue } = useFormatValue();
  const { screenType } = useScreenTypeContext();
  const upNext = screenType === "upNext" ? true : false;
  const icon = useMemo(() => {
    if (upNext) {
      if (label?.includes("Arrival")) {
        return "Arrive";
      } else if (false) {
        return "Flight";
      } else {
        return "Depart";
      }
    } else {
      return "Flight";
    }
  }, [label, upNext]);

  const labelOverride = useMemo(() => {
    if (date) {
      if (checkIn && isSameDay(date, checkIn)) {
        return `${i18n.t("cards.check-in")} ${formatValue(checkIn, "time")}`;
      }
      if (arrival && isSameDay(date, arrival)) {
        return `${i18n.t("cards.arrival")} ${formatValue(arrival, "time")}`;
      }
      return undefined;
    }
  }, [date, checkIn, arrival, formatValue]);

  const iconColour = getCategoryColours(past, category);

  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <Icon name={(category?.icon as TEventrIcons) ?? icon} iconColour={iconColour} />
        <CardText variant="bodyBold">{flightNumber}</CardText>
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "8px"
        }}>
        {visibility?.toLowerCase() === "private" ? (
          <ColouredIcon height="16px" name="Private" />
        ) : (
          visibility?.toLowerCase() === "public" && <ColouredIcon height="16px" name="Public" />
        )}
        {upNext || screenType === "team" ? (
          <DisplayLabel
            label={label}
            overrideLabel={screenType === "team" ? labelOverride : undefined}
            labelTime={labelTime}
          />
        ) : (
          <CardText variant="bodyBold">{formatValue(departure ?? "", "date")}</CardText>
        )}
      </Stack>
    </Stack>
  );
};
